var __WEBPACK_NAMESPACE_OBJECT__ = gfcf_theme_config;